var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwipointsHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_14111_29701)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 9,
    r: 9,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 9,
    r: 8.5,
    stroke: "#24A4D7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_14111_29701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0627 9.98026C14.8729 9.94848 14.6849 9.9061 14.5005 9.85491C14.1782 9.75603 13.7359 9.64124 13.3115 9.49647L12.504 9.18043C12.4574 9.15925 12.4198 9.12039 12.3983 9.07448C12.3518 8.95976 12.4073 8.83086 12.5219 8.78317L13.3115 8.47242C13.7359 8.32765 14.1764 8.21287 14.5005 8.114C14.6849 8.06279 14.8747 8.02043 15.0627 7.98863C15.5712 7.91096 15.9186 7.43953 15.8416 6.9381C15.7628 6.43666 15.2847 6.09412 14.7762 6.17006C14.547 6.20537 14.3375 6.32543 14.1925 6.50202C14.0707 6.64853 13.94 6.78804 13.8021 6.9187C13.5532 7.14823 13.2309 7.4678 12.8943 7.75735L12.2032 8.29408C12.1709 8.3188 12.1315 8.33296 12.0921 8.3347C11.9704 8.3347 11.8701 8.23758 11.8683 8.11577C11.9077 7.84914 11.9525 7.54548 11.9972 7.24179C12.085 6.80744 12.2032 6.37135 12.2784 6.04827C12.3249 5.86459 12.384 5.68454 12.4502 5.50619C12.6365 5.03124 12.3965 4.4998 11.9185 4.31618C11.4368 4.13255 10.8978 4.36912 10.7116 4.84057C10.6274 5.0542 10.6274 5.29078 10.7116 5.50266C10.7779 5.68097 10.8369 5.86284 10.8835 6.04468C10.9587 6.37135 11.0769 6.80392 11.1646 7.23825C11.2094 7.53488 11.2524 7.8262 11.2918 8.08753C11.2953 8.13167 11.2846 8.17402 11.2613 8.20759C11.1933 8.30998 11.0536 8.33645 10.948 8.26936C10.939 8.26584 10.9282 8.26054 10.9193 8.26054L10.2657 7.75206C9.92912 7.46249 9.60502 7.1447 9.35792 6.91517C9.22004 6.78095 9.08932 6.64147 8.96757 6.49846C8.64527 6.10296 8.05794 6.04117 7.65507 6.35897C7.25219 6.67678 7.19132 7.25593 7.51363 7.65318C7.66045 7.83151 7.86816 7.94981 8.09734 7.98512C8.28713 8.0169 8.47518 8.05927 8.65959 8.11045C8.98191 8.20936 9.42419 8.32411 9.84855 8.46888L10.6472 8.7814C10.6901 8.79906 10.7259 8.8273 10.751 8.86792C10.8083 8.97562 10.7635 9.11158 10.6543 9.16631C10.6472 9.16985 10.6436 9.17512 10.64 9.18043L9.85211 9.48943C9.42776 9.63418 8.98727 9.74896 8.66319 9.84783C8.47875 9.89908 8.28894 9.94142 8.10094 9.9732C7.59242 10.0509 7.24504 10.5241 7.3256 11.0255C7.40442 11.5269 7.88428 11.8695 8.39281 11.79C8.62021 11.7547 8.82614 11.6382 8.97117 11.4616C9.09292 11.3151 9.22362 11.1756 9.36149 11.0449C9.61039 10.8189 9.93269 10.4993 10.2693 10.208L10.973 9.66069C11.0071 9.63949 11.0482 9.62891 11.0894 9.63242C11.2147 9.64479 11.3043 9.75251 11.2918 9.8761C11.2918 9.87784 11.2918 9.87963 11.2918 9.88316L11.1664 10.7218C11.0787 11.1562 10.9605 11.5923 10.8853 11.9154C10.8387 12.099 10.7796 12.2791 10.7134 12.4574C10.5272 12.9324 10.7671 13.4638 11.2452 13.6474C11.7269 13.8311 12.2658 13.5945 12.452 13.123C12.5362 12.9094 12.5362 12.6728 12.452 12.4609C12.3858 12.2826 12.3267 12.1008 12.2802 11.9189C12.2049 11.5923 12.0868 11.1597 11.999 10.7253C11.9543 10.4128 11.9059 10.1003 11.8665 9.83017C11.8665 9.80725 11.8737 9.78602 11.8809 9.76484C11.9346 9.65538 12.0707 9.60772 12.1817 9.66069H12.1853L12.8961 10.2133C13.2327 10.5029 13.5568 10.8207 13.8039 11.0502C13.9418 11.1844 14.0725 11.3239 14.1943 11.4669C14.5166 11.8624 15.1039 11.9242 15.5068 11.6064C15.9097 11.2886 15.9705 10.7094 15.6482 10.3122C15.4996 10.1339 15.2901 10.0156 15.0627 9.98025L15.0627 9.98026Z",
    fill: "#20BEFD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14111_29701",
    x: 0.5,
    y: 0,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0235294 0 0 0 0 0.235294 0 0 0 0 0.6 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14111_29701"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14111_29701",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_14111_29701",
    x: 6.30713,
    y: 4.25391,
    width: 9.54736,
    height: 10.4561,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.270588 0 0 0 0 0.270588 0 0 0 0 0.270588 0 0 0 0.219608 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14111_29701"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14111_29701",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwipointsHeader);
export default __webpack_public_path__ + "static/media/swipoints_header.2b092336e54316ef7cccaddf99930f7f.svg";
export { ForwardRef as ReactComponent };